import React, { Suspense, useContext, useEffect, useState } from "react";
import "../../../App.css";
import { notifyPopupBlocked, openWithPopupCheck } from "../../../utils/popupWindow";
import VrReportOptionsMenu from "../../common/VrReportOptionsMenu";
import { isExistingVrResultVisible } from "../../../utils/atsApplicationStatus";
import { QuickLookProvider } from "../../common/QuickLook/quickLookContext";
import {
  Admin,
  BooleanField,
  Button,
  ChipField,
  Confirm,
  CustomRoutes,
  Datagrid,
  DateField,
  defaultTheme,
  DeleteButton,
  FunctionField,
  List,
  ListContextProvider,
  ListGuesser,
  NumberField,
  Resource,
  SearchInput,
  SimpleForm,
  TextField,
  TextInput,
  useDataProvider,
  useDelete,
  useGetList,
  useGetOne,
  useList,
  useCreate,
  useListContext,
  useNotify,
  useRecordContext,
  useRefresh,
} from "react-admin";
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Button as MuiButton,
  SvgIcon,
} from "@mui/material";
import { NumericFormat } from "react-number-format";
import FilterListIcon from "@mui/icons-material/FilterList";
import IconButton from "@mui/material/IconButton";

import { TableHead, TableRow, TableCell, Checkbox } from "@mui/material";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import InfoIcon from "@mui/icons-material/Info";
import { DatagridBody, RecordContextProvider } from "react-admin";
import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import ErrorIcon from "@mui/icons-material/Error";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import FolderIcon from "@mui/icons-material/Folder";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ArticleIcon from "@mui/icons-material/Article";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import ArchiveAplicant from "./ArchiveAplicant";
// import { RootState } from "../../Store/store";
import { useParams, useNavigate } from "react-router-dom";
import RestoreFromTrashIcon from "@mui/icons-material/RestoreFromTrash";
import { JSONTree } from "react-json-tree";
// import SendEmailToApplicant from "./SendEmailToApplicant";
// import ApplicantNameEdit from "./ApplicantNameEdit";
// import ReAddApplicant from "./ReAddApplicant";
// import ResendInvite from "./ResendInvite";
import { BiSolidFilePdf } from "react-icons/bi";
import { updateNewTagsForApplicantsUnconditional } from "../../../utils/newTag";
import { useSelector } from "react-redux";
import { ReactComponent as SsnIcon } from "../../../assets/images/ssn.svg";
import { canShowDocumentNewTag } from "../Fields/AtsFields";
import { canShowScreeningScoreForViewer, shouldHideSystemAssessment, shouldShowReviewPending } from "../../../utils/screeningScore";
// import SwitchApplicant from "./SwitchApplicant";


export const ToogleFilterInboxType = (props) => {
  const { setFilters, filterValues, displayedFilters } = useListContext();
  useEffect(() => {
    if (!filterValues.app_invitation_type) {
      setFilters({ app_invitation_type: "1" }, displayedFilters);
    }
  }, []);
  return (
    <>
      {/* <JSONTree data={filterValues}/> */}
      <ToggleButtonGroup
        sx={{ paddingBottom: 0.5, "& .Mui-selected": { fontWeight: 700 } }}
        size="small"
        value={filterValues.app_invitation_type}
        color="primary"
        exclusive
        onChange={(
          event: React.MouseEvent<HTMLElement>,
          newAlignment: string
        ) => {
          if (newAlignment) {
            setFilters({ app_invitation_type: newAlignment }, displayedFilters);
          }
        }}
        aria-label="Inbox"
      >
        <ToggleButton value={"1"} aria-label="Application">
          Application
        </ToggleButton>
        <ToggleButton value={"2"} aria-label="Docupload">
          Docupload
        </ToggleButton>
        <ToggleButton value={"3"} aria-label="Docupload">
          Guest Card
        </ToggleButton>
      </ToggleButtonGroup>
    </>
  );
};

export const FilterListInbox = (props) => {
  return (
    <>
      {/* <Button size='large' variant='outlined' startIcon={} label='' onClick={() => { }} /> */}
      <IconButton
        sx={{
          border: "1px solid",
          borderRadius: " 5px",
          padding: "6px",
          marginLeft: "-10px",
          marginBottom: "4.4px",
        }}
        size="medium"
        aria-label="delete"
      >
        <FilterListIcon />
      </IconButton>
    </>
  );
};

// export const filters = [
//   <SearchInput
//     variant="outlined"
//     sx={{ backgroundColor: "#fff" }}
//     placeholder="Search"
//     InputLabelProps={{
//       shrink: true,
//     }}
//     source="q"
//     alwaysOn
//   />,
//   <FilterModel source="filterList" alwaysOn />,
//   <ToogleFilterInboxType source="app_invitation_type" alwaysOn />,

//   // <TextInput alwaysOn label="Title" source="Property" variant="outlined" sx={{ backgroundColor: '#fff' }}    />,
// ];

export default function BasicPopover() {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <IconButton
        color="warning"
        style={{ color: "#F9BB04" }}
        size="small"
        aria-label="info"
        aria-describedby={id}
        onClick={handleClick}
      >
        <InfoIcon style={{ fontSize: "14" }} />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Typography sx={{ p: 2 }}>This is the Rent to Income Ratio.</Typography>
      </Popover>
    </div>
  );
}

const DatagridTableHeaderCell = ({ child, data }) => {
  return (
    <div className="badge-cell">
      {" "}
      {child.props.label || child.props.source}
    </div>
  );
};

const DatagridHeader = (props) => {
  const { children, data } = props;
  return (
    <TableHead
      sx={{ backgroundColor: "#FFFFFF", border: "0.5px solid #E0E0E0" }}
    >
      <TableRow>
        {React.Children.map(children, (child) => {
          if (child)
            if (!child.props?.hidden)
              return (
                <TableCell
                  padding="none"
                  sx={{ p: 1 }}
                  key={child?.props?.source}
                >
                  <DatagridTableHeaderCell child={child} data={data} />
                </TableCell>
              );
        })}
      </TableRow>
    </TableHead>
  );
};

const MyDatagridRow = (props) => {
  const { record, id, children } = props;
  return (
    <RecordContextProvider value={record}>
      <TableRow className={props.className}>
        {React.Children.map(children, (field) => {
          if (field)
            if (!field.props?.hidden)
              return (
                <TableCell
                  padding="none"
                  data-label={field?.props?.label || field?.props?.source}
                  sx={{ p: 1 }}
                  key={`${id}-${field?.props?.source}`}
                >
                  {field}
                </TableCell>
              );
        })}
      </TableRow>
    </RecordContextProvider>
  );
};

const MyDatagridBody = (props) => (
  <DatagridBody {...props} row={<MyDatagridRow />} />
);
const MyDatagrid = (props) => <Datagrid {...props} body={<MyDatagridBody />} />;

export const successScreenStyle = {
  border: " 1px solid #46A96F",
  background: "#E6FDF0",
  width: 40,
  height: 40,
  borderRadius: 50,
  margin: "0px 40px",
  p: 1,
};
export const errorScreenStyle = {
  background: "#FFEEEE",
  /* Error */
  border: "1px solid #FF4848",
  width: 40,
  height: 40,
  borderRadius: 50,
  margin: "0px 40px",
  p: 1,
};
export const warnScreenStyle = {
  background: "#FFF8E2",
  border: "1px solid #FFDA6A",
  width: 40,
  height: 40,
  borderRadius: 50,
  margin: "0px 40px",
  p: 1,
};

export const appStatusStyle = {
  padding: "8px 7px",
  borderRadius: "4px",
  fontWeight: "600",
  fonSize: "12px",
  lineHeight: "16px",
};

export const screenedAppStatusStyle = {
  ...appStatusStyle,
  background: "#FFF8E2",
  color: "#F9BB04",
};

export const invitedAppStatusStyle = {
  ...appStatusStyle,
  background: "#E9E9E9",
  color: "#909090",
};

export const inProgressAppStatusStyle = {
  ...appStatusStyle,
  background: "#DDF8FF",
  color: "#1CA2C2",
};
function CircularProgressWithLabel(
  props: CircularProgressProps & { value: number }
) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        variant="determinate"
        size="30px"
        {...props}
        sx={{ color: props?.value === 100 ? "green" : "orange" }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 40,
          border:
            props?.value === 100
              ? "0"
              : props?.value === 0
                ? "2px solid #E0E0E0"
                : "1px solid #E0E0E0",
        }}
      >
        {props?.value === 100 ? (
          <CheckIcon style={{ color: "green" }} />
        ) : (
          <Typography
            variant="caption"
            component="div"
            color="text.secondary"
          >{`${Math.round(props.value)}%`}</Typography>
        )}
      </Box>
    </Box>
  );
}

export function CircularStatic() {
  const record = useRecordContext();
  return (
    <>
      <CircularProgressWithLabel
        value={
          record.ApplicantStatus == "Invited"
            ? 0
            : Number(record.ApplicationCompleted)
        }
      />
    </>
  );
}

export function BasicMenu({
  socrStatus,
  documentType,
}: {
  socrStatus?: any;
  documentType?: string;
}) {
  const hasStatus = socrStatus !== undefined && socrStatus !== null && String(socrStatus).trim() !== "";
  const dropdown = hasStatus ? String(socrStatus) : documentType === "ID" ? "NA" : "Verification Required";
  const isValidLinked = dropdown === "Valid - Linked";
  const isValidStatus = dropdown === "Valid" || isValidLinked;
  const isSsnPresent =
    documentType === "SSN" && dropdown === "Verification Required";

  return (
    <div
      title={
        isSsnPresent
          ? "Present"
          : dropdown == "Verification Required"
          ? "Verif req."
          : dropdown
      }
      className={`d-flex flex-column align-items-center ${
        isSsnPresent
          ? "text-info-soft"
          : dropdown == "Invalid"
          ? "text-danger"
          : isValidStatus
          ? "text-success"
          : "text-warning"
      }`}
    >
      <p style={{ padding: "0 10px" }}>
        {isSsnPresent ? (
          <SvgIcon
            component={SsnIcon}
            inheritViewBox
            titleAccess="SSN status"
            style={{ width: "18px", height: "18px" }}
          />
        ) : dropdown == "Invalid" ? (
          <ErrorIcon color="error" />
        ) : isValidStatus ? (
          <CheckIcon color="success" />
        ) : (
          <ReportProblemIcon color="warning" />
        )}
      </p>
      {isSsnPresent
        ? "Present"
        : dropdown == "Verification Required"
        ? "Verif req."
        : isValidLinked
        ? "Valid - Linked"
        : `${dropdown.substring(0, 10)}${dropdown.length > 10 ? "..." : ""}`}
    </div>
  );
}

const GetlandloardinboxListDetailsContent = ({
  id,
  secondaryApp,
  appType,
  subsciberIdFromRecord = null,
  appInvitationType,
  applicationType,
  archiveCancelApp,
}) => {
  const { displayedFilters, filterValues, setFilters, hideFilter } =
    useListContext();
  const AppRecord = useRecordContext();

  const { id: parmSubsciberId } = useParams();
  const subsciberId = subsciberIdFromRecord || parmSubsciberId;
  const [viewAppLoadingStates, setViewAppLoadingStates] = useState({});
  // ADO 4855: which record's Generate/Report Options menu is open (a single
  // shared anchor, since the button is rendered per-row inside a
  // FunctionField render prop, not its own component -- no per-row hooks).
  const [vrReportMenuAnchor, setVrReportMenuAnchor] = useState<{
    anchorEl: HTMLElement;
    trnId: string;
  } | null>(null);
  const notify = useNotify();
  const { data, total, isLoading, error } = useGetList(
    "get_subscriber_inbox_details",
    { filter: { ApplicationNumber: id, subscriberid: subsciberId } }
  );

  const isApplicant = data?.filter((check) => check.Active == false)
  const isCheckedApplicant = ((isApplicant && isApplicant.length) == (data && data?.length - 1)) ? false : true
  const listContext = useList({ data, isLoading });
  const appSubmitted = data?.findIndex((value, index) => {
    return value.ApplicantStatus == "Submitted";
  });
  const viewerRole =
    useSelector((state: any) => state?.users?.role) ||
    JSON.parse(localStorage.getItem("userRole") || "null");
  const canSeeNewDocumentTag = canShowDocumentNewTag(viewerRole);
  const navigate = useNavigate();
  const dataProvider = useDataProvider();
  const [create] = useCreate();
  const refresh = useRefresh();
  const onClickDocsHandler = async (event, record) => {
    // get getalldocs list data
    const getalldocs = await dataProvider.getOne("getalldocs", {
      id: record?.id,
    });
    // const getApplicantDetails = await dataProvider.getOne("getApplicantDetails", { id: record?.Trnid });
    navigate("/landloard/docview", {
      state: { getalldocs: getalldocs?.data?.data, record },
    });
  };

  const onClickIndividualDocsHandler = async (event, record, documentType) => {
    // get getalldocs list data
    const getalldocs = await dataProvider.getOne("getalldocs", {
      id: record?.id,
    });
    await updateNewTagsForApplicantsUnconditional({
      create,
      applicationNumber: id,
      applicantData: record,
    });

    navigate("/landloard/docview", {
      state: {
        getalldocs: getalldocs?.data?.data?.filter((item) =>
          documentType === "ID"
            ? item.DocumentType === "License" ||
            item.DocumentType === "Barcode" ||
            item.DocumentType === "Passport" ||
            item.DocumentType === "PermanentResidentID" ||
            item.DocumentType === "Visa"
            : item.DocumentType === documentType
        ),
        record,
        showHeading: true,
      },
    });
  };

  const onClickViewAppHandler = async (event, record) => {
    const key = record?.id || record?.Trnid;
    if (viewAppLoadingStates[key]) return;

    const payloadData = {
      applicationNumber: record?.AppID,
      applicantID: record?.id,
    };
    setViewAppLoadingStates((prev) => ({
      ...prev,
      [key]: true,
    }));

    try {
      const viewAppReport = await dataProvider.getOne("viewappreport", {
        id: payloadData,
      });
      openWithPopupCheck(`${viewAppReport?.data?.data}`, "_blank", undefined, {
        onBlocked: notifyPopupBlocked(notify),
      });
    } catch (error: any) {
      notify(error?.message || "Failed to open application report", {
        type: "warning",
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    } finally {
      setViewAppLoadingStates((prev) => ({
        ...prev,
        [key]: false,
      }));
    }
  };

  // ADO 4855: opens the Generate Report Options / Report Options menu
  // (content mode + preview/download) for this record's submitted report.
  const onClickPrintResultHandler = (event: React.MouseEvent<HTMLElement>, record) => {
    setVrReportMenuAnchor({ anchorEl: event.currentTarget, trnId: record.Trnid });
  };

  return (
    <>
      <ListContextProvider value={listContext}>
        <MyDatagrid
          header={<DatagridHeader />}
          sx={{
            "& .RaDatagrid-rowEven": { backgroundColor: "#F9F9F9" },
            "& .RaDatagrid-expandIcon": { color: "#fff" },
            "& .RaDatagrid-expandIconCell": { backgroundColor: "primary.main" },
            "& .RaDatagrid-headerCell": {
              fontWeight: "bold",
              fontSize: 12,
            },
            "& .RaDatagrid-table": {
              fontSize: 12,
            },
            "& .MuiToggleButton-root.Mui-selected": {
              fontWeight: 700,
            },
            "& th.MuiTableCell-root.MuiTableCell-head": {
              textAlign: "center",
            },
            "& th:nth-child(1).MuiTableCell-root.MuiTableCell-head,th:nth-child(2).MuiTableCell-root.MuiTableCell-head":
            {
              textAlign: "center",
            },
            "& .MuiTableRow-root.RaDatagrid-row": {
              verticalAlign: "top",
            },
          }}
        >
          <FunctionField
            source="Name"
            label="Name"
            render={(record) => {
              return (
                <>
                  <Box display={"flex"} justifyContent={"start"}>
                    <Typography
                      title={`${record.FirstName} ${record.MiddleName} ${record.LastName}`}
                      style={{
                        maxWidth: "150px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "inline-block",
                      }}
                    >
                      {record.FirstName} {record.MiddleName} {record.LastName}
                    </Typography>
                  </Box>
                  <Box>
                    <small className="applicant_type">
                      {record.ApplicantType}
                    </small>{" "}
                    {/* {archiveCancelApp && <ApplicantNameEdit record={record} />} */}
                  </Box>
                </>
              );
            }}
          />
          <FunctionField
            label={"Status"}
            source="Status"
            render={(record) => {
              return (
                <Box
                  display={"flex"}
                  justifyContent="center"
                  alignItems={"center"}
                >
                  {(filterValues?.app_invitation_type == 1 ||
                    applicationType == "Application") && <CircularStatic />}
                  <ChipField
                    sx={
                      record.ApplicationStatus == "Screening"
                        ? screenedAppStatusStyle
                        : invitedAppStatusStyle
                    }
                    source="ApplicantStatus"
                  />
                </Box>
              );
            }}
          />
          <FunctionField
            source="ID"
            render={(record) => {
              // Story 4622: hide system-determined OCR tiles from non-reviewers until
              // a Docuverus Super Admin completes manual review.
              if (shouldHideSystemAssessment(AppRecord?.ApplicationStatus ?? record?.ApplicationStatus, viewerRole))
                return null;
              return (
                record.ApplicantStatus != "Invited" &&
                record?.ApplicantStatus !== "Removed" && (
                  <Box>
                    {record.IDS == "No" && (
                      <div className="d-flex flex-column align-items-center">
                        <p style={{ padding: "0 10px" }}>
                          <CloseIcon />
                        </p>
                        {record.IsRequiredID && (
                          <span style={{ color: "orange" }}> Doc Req</span>
                        )}
                      </div>
                    )}
                    {record.IDS == "Yes" && (
                      <div
                        className="d-flex flex-column align-items-center"
                        onClick={shouldShowReviewPending(record.IDReviewed, viewerRole) ? undefined : (event) => onClickIndividualDocsHandler(event, record, "ID")}
                        style={shouldShowReviewPending(record.IDReviewed, viewerRole) ? undefined : { cursor: "pointer" }}
                      >
                        {shouldShowReviewPending(record.IDReviewed, viewerRole)
                          ? <span style={{ fontSize: 11, color: "#888", padding: "0 6px" }}>Review Pending</span>
                          : <BasicMenu socrStatus={record.IDSOCRStatus} documentType="ID" />}
                      </div>
                    )}
                    <div className="badge-cell d-flex flex-column align-items-center"

                    >
                      {" "}
                      {canSeeNewDocumentTag && record?.NewTagID ? <em>New</em> : <></>}
                    </div>
                  </Box>
                )
              );
            }}
          />
          <FunctionField
            source="SSN"
            render={(record) => {
              if (shouldHideSystemAssessment(AppRecord?.ApplicationStatus ?? record?.ApplicationStatus, viewerRole))
                return null;

              return (
                record.ApplicantStatus != "Invited" &&
                record?.ApplicantStatus !== "Removed" && (
                  <Box>
                    {record.SSN == "No" && (
                      <div className="d-flex flex-column align-items-center">
                        <p style={{ padding: "0 10px" }}>
                          <CloseIcon />
                        </p>
                        {record.IsRequiredSSN && (
                          <span style={{ color: "orange" }}>Doc Req</span>
                        )}
                      </div>
                    )}
                    {record.SSN == "Yes" && (
                      <div
                        className="d-flex flex-column align-items-center"
                        onClick={shouldShowReviewPending(record.SSNReviewed, viewerRole) ? undefined : (event) => onClickIndividualDocsHandler(event, record, "SSN")}
                        style={shouldShowReviewPending(record.SSNReviewed, viewerRole) ? undefined : { cursor: "pointer" }}
                      >
                        {shouldShowReviewPending(record.SSNReviewed, viewerRole)
                          ? <span style={{ fontSize: 11, color: "#888", padding: "0 6px" }}>Review Pending</span>
                          : <BasicMenu socrStatus={record.SSNSOCRStatus} documentType="SSN" />}
                      </div>
                    )}
                    <div
                      className="badge-cell d-flex flex-column align-items-center"

                    >
                      {" "}
                      {canSeeNewDocumentTag && record?.NewTagSSN ? <em>New</em> : <></>}
                    </div>
                  </Box>
                )
              );
            }}
          />
          {filterValues?.app_invitation_type != 3 && (
            <FunctionField
              source="Income"
              render={(record) => {
                if (shouldHideSystemAssessment(AppRecord?.ApplicationStatus ?? record?.ApplicationStatus, viewerRole))
                  return null;
                return (
                  record.ApplicantStatus != "Invited" &&
                  record?.ApplicantStatus !== "Removed" && (
                    <Box>
                      {record.Income == "No" && (
                        <div className="d-flex flex-column align-items-center">
                          <p style={{ padding: "0 10px" }}>
                            <CloseIcon />
                          </p>
                          {(record.IsRequiredIncome || record?.IncomeSOCRStatus === "Verification Required") && (
                            <span style={{ color: "orange" }}>Doc Req</span>
                          )}
                        </div>
                      )}
                      {record.Income == "Yes" && (
                        <div
                          className="d-flex flex-column align-items-center"
                          onClick={shouldShowReviewPending(record.IncomeReviewed, viewerRole) ? undefined : (event) => onClickIndividualDocsHandler(event, record, "Paystub")}
                          style={shouldShowReviewPending(record.IncomeReviewed, viewerRole) ? undefined : { cursor: "pointer" }}
                        >
                          {shouldShowReviewPending(record.IncomeReviewed, viewerRole)
                            ? <span style={{ fontSize: 11, color: "#888", padding: "0 6px" }}>Review Pending</span>
                            : <BasicMenu socrStatus={record?.IncomeSOCRStatus} />}
                        </div>
                      )}
                      {record.Income == "Yes" && !shouldShowReviewPending(record.IncomeReviewed, viewerRole) && (
                        <FunctionField
                          source="currency"
                          render={(record) => {
                            return (
                              <div className="d-flex flex-column align-items-center">
                                <NumericFormat
                                  thousandSeparator=","
                                  displayType="text"
                                  thousandsGroupStyle="thousand"
                                  decimalScale={2}
                                  prefix="$"
                                  value={record.IncomeValue}
                                />
                              </div>
                            );
                          }}
                        />
                      )}
                      <div
                        className="badge-cell d-flex flex-column align-items-center"

                      >
                        {" "}
                        {canSeeNewDocumentTag && record?.NewTagIncome ? <em>New</em> : <></>}
                      </div>
                    </Box>
                  )
                );
              }}
            />
          )}
          {filterValues?.app_invitation_type != 3 && (
            <FunctionField
              source="Banking"
              render={(record) => {
                if (shouldHideSystemAssessment(AppRecord?.ApplicationStatus ?? record?.ApplicationStatus, viewerRole))
                  return null;
                return (
                  record.ApplicantStatus != "Invited" &&
                  record?.ApplicantStatus !== "Removed" && (
                    <Box>
                      {record.Banking == "No" && (
                        <div className="d-flex flex-column align-items-center">
                          <p style={{ padding: "0 10px" }}>
                            <CloseIcon />
                          </p>
                          <span style={{ color: "orange" }}>Doc Req</span>
                        </div>
                      )}
                      {record.Banking == "Yes" && (
                        <div
                          className="d-flex flex-column align-items-center"
                          onClick={shouldShowReviewPending(record.BankingReviewed, viewerRole) ? undefined : (event) => onClickIndividualDocsHandler(event, record, "Bank Statement")}
                          style={shouldShowReviewPending(record.BankingReviewed, viewerRole) ? undefined : { cursor: "pointer" }}
                        >
                          {shouldShowReviewPending(record.BankingReviewed, viewerRole)
                            ? <span style={{ fontSize: 11, color: "#888", padding: "0 6px" }}>Review Pending</span>
                            : <BasicMenu socrStatus={record.BankingSOCRStatus} />}
                        </div>
                      )}
                      <div
                        className="badge-cell d-flex flex-column align-items-center"

                      >
                        {" "}
                        {canSeeNewDocumentTag && record?.NewTagBanking ? <em>New</em> : <></>}
                      </div>
                    </Box>
                  )
                );
              }}
            />
          )}
          {filterValues?.app_invitation_type != 3 && (
            <FunctionField
              source="Other"
              render={(record) => {
                return (
                  record.ApplicantStatus != "Invited" &&
                  record?.ApplicantStatus !== "Removed" && (
                    <Box>
                      {record.Misc == "No" && (
                        <div className="d-flex flex-column align-items-center">
                          <p style={{ padding: "0 10px" }}>
                            <CloseIcon />
                          </p>
                          {record.IsRequiredID && "No Doc"}
                        </div>
                      )}
                      {record.Misc == "Yes" && (
                        <div className="d-flex flex-column align-items-center">
                          <MuiButton
                            sx={{
                              justifyContent: "center",
                              padding: "0 10px",
                              display: "flex",
                              flexDirection: "column",
                              "& .MuiButton-startIcon.MuiButton-iconSizeMedium":
                                { margin: 0 },
                            }}
                            startIcon={<CheckIcon color="primary" />}
                            onClick={(event) =>
                              onClickIndividualDocsHandler(
                                event,
                                record,
                                "Other"
                              )
                            }
                          >
                            View
                          </MuiButton>
                        </div>
                      )}

                      <div
                        className="badge-cell d-flex flex-column align-items-center"

                      >
                        {" "}
                        {canSeeNewDocumentTag && record?.NewTagOther ? <em>New</em> : <></>}
                      </div>
                    </Box>
                  )
                );
              }}
            />
          )}
          {appType == "1" && (
            <FunctionField
              source="Docs"
              render={(record) => {
                return (
                  archiveCancelApp &&
                  record?.ApplicantDocs &&
                  record.ApplicantStatus != "Invited" &&
                  record?.ApplicantStatus !== "Removed" && (
                    <Box display={"flex"} justifyContent={"center"}>
                      <MuiButton
                        onClick={(event) => onClickDocsHandler(event, record)}
                        sx={{
                          ".MuiButton-startIcon": { paddingLeft: "10px" },
                          minWidth: "80px",
                          justifyContent: "center",
                          display: "flex",
                          flexDirection: "column",
                          textTransform: "capitalize",
                        }}
                        startIcon={<FolderIcon />}
                      >
                        View
                      </MuiButton>
                    </Box>
                  )
                );
              }}
            />
          )}
          {appType == "1" && (
            <FunctionField
              source="App"
              render={(record) => {
                return (
                  record.ApplicantStatus != "Invited" &&
                  record?.ApplicantStatus !== "Removed" &&
                  record.ApplicantStatus === "Submitted" && (
                    <Box display={"flex"} justifyContent={"center"}>
                      <MuiButton
                        onClick={(event) =>
                          onClickViewAppHandler(event, record)
                        }
                        disabled={Boolean(
                          viewAppLoadingStates[record?.id || record?.Trnid]
                        )}
                        sx={{
                          ".MuiButton-startIcon": { paddingLeft: "10px" },
                          minWidth: "80px",
                          justifyContent: "center",
                          display: "flex",
                          flexDirection: "column",
                          textTransform: "capitalize",
                        }}
                      // startIcon={<PictureAsPdfIcon />}
                      >
                        {/* View */}
                        {viewAppLoadingStates[record?.id || record?.Trnid] ? (
                          <Box sx={{ display: "flex" }}>
                            <CircularProgress size="25px" />
                          </Box>
                        ) : (
                          <>
                            <PictureAsPdfIcon />
                            View
                          </>
                        )}
                      </MuiButton>
                    </Box>
                  )
                );
              }}
            />
          )}

          {/* {appInvitationType !== 3 && (
            <FunctionField
              source="Action"
              render={(record) => {
                console.log("record", record)
                return (
                  archiveCancelApp && (
                    <Box display={"flex"} justifyContent={"center"}>
                      {record.ApplicantType == "Applicant" ? (
                        (data && data?.length > 1 && isCheckedApplicant) ? (
                          <div className="modal-sm">
                          </div>)
                          :
                          <small>&nbsp;</small>
                      ) : (record?.Active &&
                        record?.ApplicantStatus == "Invited") ||
                        (record?.Active &&
                          record?.ApplicantStatus == "In Progress") ? (
                        <ArchiveAplicant
                          record={record}
                          subsciberId={subsciberId}
                        />
                      ) : record?.ApplicantStatus == "Removed" ? (
                        <ReAddApplicant
                          record={record}
                          subsciberId={subsciberId}
                        />
                      ) : (
                        ""
                      )}
                    </Box>
                  )
                );
              }}
            />
          )} */}
 
          <FunctionField
            label="Result"
            render={(record) => {
              // Story 4622: hide the screening report from non-reviewers until a
              // Docuverus Super Admin completes manual review.
              // Reviewers can still open existing results after a new applicant is added.
              const applicationStatus =
                AppRecord?.ApplicationStatus ?? record?.ApplicationStatus;
              const showResult = isExistingVrResultVisible(
                applicationStatus,
                record?.Score,
                record?.ApplicantStatus, record?.HasPreservedScreeningReport
              );
              return (
              (!shouldHideSystemAssessment(applicationStatus, viewerRole) ||
                canShowScreeningScoreForViewer(record?.Score, applicationStatus, viewerRole, record?.HasPreservedScreeningReport)) &&
              showResult &&
              archiveCancelApp && (
                <MuiButton
                  sx={{
                    ".MuiButton-startIcon": { paddingLeft: "10px" },
                    minWidth: "80px",
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                    textTransform: "capitalize",
                    width: "100%",
                  }}
                  onClick={(event) => onClickPrintResultHandler(event, record)}
                  startIcon={<BiSolidFilePdf />}
                  variant="text"
                  color="primary"
                >
                  View
                </MuiButton>
              )
              );
            }}
          />

          {/* <FunctionField
            source="Message"
            render={(record) => {
              return (
                <>
                  {archiveCancelApp && (
                    <Box display={"flex"} justifyContent={"center"}>
                      {((appInvitationType === 1 ||
                        AppRecord?.ApplicationType === "Application" ||
                        filterValues.app_invitation_type == "1") &&
                        record.ApplicantStatus === "Invited") ||
                        appInvitationType === 2 ||
                        AppRecord?.ApplicationType === "Doc Upload" ||
                        filterValues.app_invitation_type == "2" ||
                        appInvitationType === 3 ||
                        AppRecord?.ApplicationType === "Guest Card" ||
                        filterValues.app_invitation_type == "3" ? (
                        <ResendInvite
                          record={record}
                          ApplicationNumber={id}
                          subscriberId={subsciberId}
                        />
                      ) : null}
                      {record?.ApplicantStatus !== "Removed" && (
                        <SendEmailToApplicant record={[record]} />
                      );
                      )}
                    </Box>
                  )}
                </>
              );
            }}
          /> */}
        </MyDatagrid>
      </ListContextProvider>
      <VrReportOptionsMenu
        trnId={vrReportMenuAnchor?.trnId}
        anchorEl={vrReportMenuAnchor?.anchorEl ?? null}
        onClose={() => setVrReportMenuAnchor(null)}
      />
    </>
  );
};

export const GetlandloardinboxListDetails = (props: any) => (
  <QuickLookProvider>
    <GetlandloardinboxListDetailsContent {...props} />
  </QuickLookProvider>
);
